import React from "react";

interface RCARootCauseSectionProps {
  identified: boolean;
  description: string;
  onChange: (field: "rootCauseIdentified" | "rootCauseDescription", value: any) => void;
  readOnly: boolean;
}

const RCARootCauseSection: React.FC<RCARootCauseSectionProps> = ({
  identified,
  description,
  onChange,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">
        I. Root Cause Analysis - Final Part
      </h3>
      <div>
        <label className="flex text-sm font-medium mb-1 items-center gap-2">
          <input
            type="checkbox"
            checked={identified}
            onChange={(e) =>
              onChange("rootCauseIdentified", e.target.checked)
            }
            disabled={readOnly}
          />
          IS THE ROOT CAUSE FOR THE INCIDENT IDENTIFIED?
        </label>
      </div>
      {identified && (
        <div>
          <label className="block text-sm font-medium mb-1">
            Root Cause Description
          </label>
          <textarea
            value={description}
            onChange={(e) =>
              onChange("rootCauseDescription", e.target.value)
            }
            className="w-full p-2 border rounded"
            rows={4}
            readOnly={readOnly}
            placeholder="Describe the identified root cause"
          />
        </div>
      )}
    </div>
  );
};

export default RCARootCauseSection;
